import React from "react";

export const Logo = ({ size = 28, color = "#F5F3EE", showText = true, className = "" }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`} aria-label="Romain Bruneau">
      <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Camera body outline - minimalist square */}
        <rect x="6" y="14" width="52" height="40" stroke={color} strokeWidth="1.6" />
        {/* Top viewfinder block */}
        <path d="M22 14 L26 8 L38 8 L42 14" stroke={color} strokeWidth="1.6" fill="none" />
        {/* Lens aperture - precise circles */}
        <circle cx="32" cy="34" r="13" stroke={color} strokeWidth="1.6" />
        <circle cx="32" cy="34" r="7.5" stroke={color} strokeWidth="1.4" />
        <circle cx="32" cy="34" r="2.2" fill={color} />
        {/* Aperture blade hints - 3 thin lines */}
        <line x1="32" y1="21" x2="32" y2="27" stroke={color} strokeWidth="1" />
        <line x1="43.2" y1="40.5" x2="38" y2="37.5" stroke={color} strokeWidth="1" />
        <line x1="20.8" y1="40.5" x2="26" y2="37.5" stroke={color} strokeWidth="1" />
        {/* Top-right indicator dot */}
        <circle cx="52" cy="20" r="1.4" fill={color} />
      </svg>
      {showText && (
        <span
          className="font-display tracking-[0.18em] uppercase"
          style={{ color, fontSize: size * 0.45, fontWeight: 500, letterSpacing: "0.22em" }}
        >
          Romain&nbsp;Bruneau
        </span>
      )}
    </div>
  );
};

export default Logo;
